<template>
  <div class="ce-requestSampleForm">
    <div
      class="ce-requestSampleForm-toggle"
      @click.prevent="show">
      <slot />
    </div>

    <modal
      v-if="visible"
      :headline="headline"
      :description="description"
      class="ce-requestSampleFormModal"
      @close="close">
      <request-sample-form
        v-if="!finished"
        :additional-data="additionalData"
        @finished="finished = true" />
      <div
        v-if="finished"
        class="ce-modalContent">
        <p>{{ $t('requestSampleForm.finishedMessage') }}</p>

        <div class="mt4">
          <button
            class="ce-btn ce-btn-light ce-btn--fullWidth"
            @click.prevent="close">
            {{ $t('requestSampleForm.finishedCloseCta') }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import RequestSampleForm from 'components/forms/RequestSampleForm.vue';

export default {
  components: { RequestSampleForm },
  props: {
    headline: {
      type: String,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    additionalData: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      finished: false
    };
  },
  methods: {
    reset() {
      this.finished = false;
    },
    show() {
      this.visible = true;
    },
    close() {
      this.reset();
      this.visible = false;
    }
  }
};
</script>

<style lang="less">
  .ce-requestSampleForm {
    .ce-requestSampleForm-toggle {
      display: inline-block;
      cursor: pointer;
    }
  }
</style>
